module.exports = __webpack_public_path__ + "img/logo-entreprises-partenaires-white.82ba0c7c.png";